export const giftsReceivedTransformer = (giftsReceived) => {
  const transformedGiftTable = giftsReceived.map((order) => ({
    id: order.internal_order_number,
    orderId: order.sears_order_number,
    whoGaveTheGift: order.guest_name || "Anónimo",
    price: order.total_paid,
    congratulationMessage: order.congrats_message,
    totalAmount: order.quantity_products,
    orderDate: order.payment_date,
    status: order.thanks_message_sent,
    orderStatus: order.order_status,
    orderStatusId: order.order_status_id,
    addressId: order.address_id,
    salesCheck: order.sales_check,
    plan: order.plan_id,
    shipping_method: order.shipping_method,
    hasEmail: order.hasEmail,
    product_description: order.products[0].product_name || "Regalo sorpresa",
    product_image: order.products[0].product_image,
    thanksMessageSent: order.thanks_message_sent,
  }));

  return transformedGiftTable;
};

export const orderDetailsTransformer = (orderItems) => {
  const transformedOrderDetails = orderItems.map((item) => ({
    article: {
      id: item.product_sears_id,
      price: item.unit_price,
    },
    unitPrice: item.unit_price,
    price: item.unit_price,
    amount: item.quantity,
    description_pos: item.description_pos,
    qty_paid: item.quantity,
    qty_refunded: item.quantity_refunded
  }));

  return transformedOrderDetails;
};
